// Helpers partagés export vectoriel (par-couche + zone) — lot 2a.
export const EXPORT_EVENT = 'gis-vector-export-progress'
export const EXPORT_TIMEOUT_MS = 5 * 60 * 1000

// VITE_URL = base axios (=.../api en dev) ; le socket écoute la racine (sans /api).
export function resolveSocketUrl() {
  const rawUrl = import.meta.env.VITE_URL || 'https://data.eldatechnology.fr/api'
  return (
    rawUrl.replace(/\/api\/?$/, '') ||
    import.meta.env.VITE_API_URL ||
    'http://localhost:3000'
  )
}

export function triggerDownload(url) {
  const link = document.createElement('a')
  link.href = url
  link.rel = 'noopener'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
